import type { IndexableType } from 'dexie';
import { NomadDB } from '~/db/NomadDB.js';
import type { MyFutureBoxSchema } from '@/types/schema';

export const getMyFutureBoxesService = (db: NomadDB) => {
  const get = async (params: any): Promise<MyFutureBoxSchema> => {
    const box = await db.myFutureBoxes.get(params);
    return box;
  };

  const findByIds = async (ids: string[]): Promise<MyFutureBoxSchema[]> => {
    return await db.myFutureBoxes.where('id').anyOf(ids).toArray();
  };

  const findAll = async (): Promise<MyFutureBoxSchema[]> => {
    return await db.myFutureBoxes.toArray();
  };

  const update = async (
    myFutureBox: MyFutureBoxSchema,
    params: any = null
  ): Promise<void> => {
    const { id } = myFutureBox;
    const data = params || myFutureBox;
    await db.myFutureBoxes.update(id, data);
  };

  return {
    get,
    findByIds,
    findAll,
    update,
  };
};
